const Button = (props) => {
  const { children, format, active, ...rest } = props;
  return (
    <button className={active ? 'btnActive' : ''} title={format} {...rest} style={{ height: '20px', margin: '0 2px' }}>
      {children}
    </button>
  );
};

export default Button;
